import * as React from "react"
import {
	SlideShow,
	Paper,
	IconButton,
	Product,
	ProductItem,
	Card,
	SocialStructuredData,
	Seo,
	ProductCarousel,
	Sale,
} from "components"
import { Row, Col } from "reactstrap"
import { products } from "./data"
import { AfterPage } from "types/afterjs"
import fetchHome from "./actions"
import { Home } from "types/home"
import { Link } from "react-router-dom"
import { useInView } from "react-intersection-observer"

import "./home.scss"

interface Media extends React.HTMLProps<HTMLDivElement> {
	source: string
}

const Media: React.FC<Media> = ({ source, className }) => {
	const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "100px" })
	return (
		<Card className={className} title="رسانه">
			<iframe
				ref={ref}
				src={inView ? source : ""}
				allowFullScreen
				className="home__media"
				title="video"
			/>
		</Card>
	)
}

const HomePage: AfterPage<{ data: Home }> = ({ data }) => {
	return (
		<>
			<Seo
				title="خانه"
				description="مرجع آنتی ویروس  ایران معرفی و ارائه انواع آنتی ویروس در ایران، راه ها و روش های جلوگیری از ویروس های باجگیر و فروش نسخه سازمانی (تحت شبکه)"
				path="/"
			/>
			<Row>
				<Col lg={12}>
					<Paper>
						<SlideShow buttons autoplay dots slides={data.slides} />
					</Paper>
				</Col>
				<Col lg={6} className="mt-3 order-lg-0 order-1">
					<Paper className="home__box-image home__box-image--right">
						<div className="home__box home__box--right">
							<p>آنتی ویروس سازمانی (تحت شبکه)</p>
							<Link to="/shop/business">
								<IconButton color="tealish">خرید</IconButton>
							</Link>
						</div>
					</Paper>
				</Col>
				<Col lg={6} className="mt-3">
					<Paper className="home__box-image home__box-image--left">
						<div className="home__box home__box--left">
							<p>برنامه‌های رمزگشا برای ویروس باجگیر</p>
							<Link to="/post/برنامههای-رمزگشا-برای-ویروس-باجگیر-Ransomware-Decryptor">
								<IconButton color="coral">مقالات</IconButton>
							</Link>
						</div>
					</Paper>
				</Col>
				{products.map((product, index) => (
					<Col
						key={product.text}
						className={`mt-3 order-${index * 2} order-lg-${index}`}
						lg={4}
					>
						<Product {...product} />
					</Col>
				))}
				<Col className="mt-3 order-1 order-lg-4" lg={4}>
					<Media
						className="h-100"
						source="https://www.aparat.com/video/video/embed/videohash/qOzBD/vt/frame"
					/>
				</Col>
				<Col className="mt-3 d-none d-lg-block order-lg-4" lg={8}>
					<Sale products={data.sale} />
				</Col>
				<Col className="mt-3 order-3 order-lg-5" lg={12}>
					<Card title="پر فروش ترین محصولات">
						<ProductCarousel>
							{data.products.map((product, index) => (
								<ProductItem
									key={product.url + index}
									{...product}
								/>
							))}
						</ProductCarousel>
					</Card>
				</Col>
			</Row>
			<SocialStructuredData />
		</>
	)
}

HomePage.getInitialProps = async () => {
	try {
		const { data } = await fetchHome()
		return { data }
	} catch (error) {
		return { error }
	}
}

export default HomePage
